<ng-select #multiSelect [multiple]="true" [disabled]="disabled"
           [items]="items"
           [(ngModel)]="activeItems"
           (data)="refreshValue($event)"
           (selected)="selected($event)"
           (removed)="removed($event)"
           (change)="filter($event)"
           [virtualScroll]="true"
           [appendTo]="'body'"
           [compareWith]="userCompare ? compareColumns : null"
           bindLabel={{display}}
           bindValue={{key}}
           placeholder="{{placeholder}}"></ng-select>

